import 'animate.css/animate.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import {observer} from 'mobx-react';
import * as React from 'react';
import {lazy, Suspense} from "react";
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Error404 from "./components/error-404";
import Footer from './components/footer/footer';
import NavMenu from './components/nav-menu/nav-menu';
import ScrollToTop from "./components/scroll-to-top";
import Toaster from "./components/toaster/toaster";
import './html-editor.css';
import './index.css';

const About = lazy(() => import('./components/about'));
const Blog = lazy(() => import('./components/blog/blog'));
const BlogDetails = lazy(() => import('./components/blog/blog-details'));
const Cart = lazy(() => import('./components/cart/cart'));
const CheckoutDetails = lazy(() => import('./components/checkout/checkout-details'));
const CheckoutFailure = lazy(() => import('./components/checkout/checkout-failure'));
const CheckoutForm = lazy(() => import('./components/checkout/checkout-form'));
const CheckoutSuccess = lazy(() => import('./components/checkout/checkout-success'));
const Contact = lazy(() => import('./components/contact/contact'));
const Home = lazy(() => import('./components/home/home'));
const Privacy = lazy(() => import('./components/privacy/privacy'));
const ProductDetails = lazy(() => import('./components/product/product-details'));
const ProductList = lazy(() => import('./components/product/product-list'));
const Terms = lazy(() => import('./components/terms/terms'));

@observer
class App extends React.Component {
    public render() {
        return (
            <div className="container-fullwidth text-center">
                <Toaster/>
                <Router>
                    <ScrollToTop/>
                    <div className="min-vh-100">
                        <NavMenu/>
                        <Suspense fallback={<div/>}>
                            <Switch>
                                <Route exact={true} path="/" component={Home}/>
                                <Route path="/products" component={ProductList}/>
                                <Route path="/product/:id" component={ProductDetails}/>
                                <Route exact={true} path="/blog" component={Blog}/>
                                <Route path="/blog/posts/:id" component={BlogDetails}/>
                                <Route path="/about" component={About}/>
                                <Route path="/cart" component={Cart}/>
                                <Route exact={true} path="/checkout" component={CheckoutForm}/>
                                <Route path="/checkout/:id" component={CheckoutDetails}/>
                                <Route path="/checkout-success" component={CheckoutSuccess}/>
                                <Route path="/checkout-failure" component={CheckoutFailure}/>
                                <Route path="/contact" component={Contact}/>
                                <Route path="/terms" component={Terms}/>
                                <Route path="/privacy" component={Privacy}/>
                                <Route component={Error404}/>
                            </Switch>
                        </Suspense>
                    </div>
                    <Footer/>
                </Router>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx